import { createUserBySchoo, getAllStudentsBySchoolId, updateUserBySchoo } from '../../../services/SchoolService.js';
export default {
    async saveNewStudent(context, studentPayload) {
        const response = await createUserBySchoo(studentPayload, context.rootGetters['school/getSchoolId'], context.rootGetters['auth/getToken']);        
        const newUser = {...response.data.user};
        context.commit('saveNewUser', newUser);
    },
    removeCurrentStudentCreated(context) {
        context.commit('saveNewUser', null);
    },
    async loadStudents(context, payload = false) {
        if (!payload.forceRefresh && !context.getters.shouldUpdate) return;
        const students = await getAllStudentsBySchoolId(context.rootGetters['school/getSchoolId'], context.rootGetters['auth/getToken']);
        context.commit('setStudents', students.data.students);
        context.commit('setFetchTimestamp');
    },
    setStudentToEdit(context, studentPayload) {
        context.commit('setStudentToEdit', studentPayload);
    },
    async updateStudent(context, studentPayload) {
        const response = await updateUserBySchoo(studentPayload, context.rootGetters['school/getSchoolId'], context.rootGetters['auth/getToken']);
        const updatedUser = {...response.data.user};
        context.commit('updateStudent', updatedUser);
        context.commit('updateListUsers', updatedUser);
        context.commit('setStudentToEdit', updatedUser);

    },
    removeStudentToEdit(context) {
        context.commit('setStudentToEdit', null);
    }
}